export default __webpack_public_path__ + "static/media/news51.d44c7100.jpg";